export default "__VITE_ASSET__CuhM697F__"